import { Grid } from "@material-ui/core";
import { LynxButton } from "components/LynxButton/LynxButton";
import React from "react";
import { LynxPaginationProps } from "./LynxPaginationProps";
import { lynxPaginationStyles } from "./LynxPaginationStyles";

export function LynxPagination({
    isLastPage,
    page,
    onPageChange,
}: LynxPaginationProps) {
    const classes = lynxPaginationStyles();

    return (
        <Grid container className={classes.root} spacing={1}>
            <Grid item>
                <LynxButton
                    className={classes.button}
                    classes={{
                        disabled: classes.buttonDisabled,
                    }}
                    onClick={() => onPageChange("back")}
                    disabled={page <= 1}
                >
                    Previous
                </LynxButton>
            </Grid>
            {/* <div className={classes.pageCounter}>
                <Typography variant="subtitle1" component="span">
                    {page}/{0}
                </Typography>
            </div> */}
            <Grid item>
                <LynxButton
                    className={classes.button}
                    onClick={() => onPageChange("forward")}
                    disabled={isLastPage}
                    classes={{
                        disabled: classes.buttonDisabled,
                    }}
                >
                    Next
                </LynxButton>
            </Grid>
        </Grid>
    );
}
